import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';

/**
 * NOT_BASIC_01_02 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *   - requiredWhen: 언제 필수인지 조건
 *
 * - mapper: 저장/삭제/조회 API payload 생성 규칙
 *   - mapParamsBySchema(mapper, context)로 payload를 만듬
 *   - mapRowsBySchema(rows, mapper, context)로 payload를 만듬
 *   - context에는 userInfo 등이 들어오며(mapParamsBySchema에 기본족으로 정의되어 있음),
 *     화면에서 추가로 필요한 값(coCd 등)을 context로 넘겨줄 수 있다.
 */
export const NOT_BASIC_01_02_Schema = {
  fields: {
    chaebunNo: { initial: '', label: '체번' },
    coCd: { initial: '', label: '회사코드' },
    title: { initial: '', label: '제목', required: 'Y' },
    comment: { initial: '', label: '내용', required: 'Y' },
    gubun: { initial: '0', label: '구분' },
    gubunDtl: { initial: '', label: '구분 상세' },
    gubunDtlNm: { initial: '', label: '구분 상세명' },
    custCd: { initial: '', label: '사업장코드' },
    endDate: { initial: '', label: '종료일' },
    noticeYn: { initial: 'N', label: '공지여부' },
    noticeType: { initial: '0', label: '게시 환경' },
    isPublic: { initial: '0', label: '공개여부' },
    createId: { initial: '', label: '작성자' },
    // 파일 관련 필드
    noticeFId: { initial: '', label: '파일ID' },
    fileName: { initial: '', label: '파일명' },
    saveName: { initial: '', label: '저장파일명' },
    filePath: { initial: '', label: '파일경로' },
    previewFilePath: { initial: '', label: '미리보기파일경로' },
    fileType: { initial: '', label: '파일타입' },
    preview: { initial: '', label: '미리보기URL' },
    deleted: { initial: false, label: '삭제여부' },
  },

  mapper: {
    search1: {
      CoCd: (_, context) =>
        Commons.EncryptAES(context.search?.coCd || '') || '',
    },

    search2: {
      ChaebunNo: (_, context) =>
        Commons.EncryptAES(context.chaebunNo || '') || '',
    },
    search3: {
      AuthCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.authCd || '') || '',
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd || ''
        ) || '',
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },

    save1: {
      ChaebunNo: (row) =>
        row.chaebunNo ? Commons.EncryptAES(row.chaebunNo) : null,
      Title: (row) => Commons.EncryptAES(row.title || '') || '',
      EndDate: (row) => {
        const dateValue = row.endDate || dayjs().format('YYYY-MM-DD');
        return Commons.EncryptAES(dateValue) || '';
      },
      NoticeYn: (row) => Commons.EncryptAES(row.noticeYn || 'N') || '',
      NoticeType: (row) =>
        Commons.EncryptAES(String(row.noticeType ?? '0')) || '',
      Gubun: (row) => Commons.EncryptAES(row.gubun || '0') || '',
      GubunDtl: (row) => {
        const gubunDtlValue = Array.isArray(row.gubunDtl)
          ? row.gubunDtl.join(',')
          : row.gubunDtl || '';
        return Commons.EncryptAES(gubunDtlValue) || '';
      },
      GubunDtlNm: (row) => {
        const gubunDtlNmValue = Array.isArray(row.gubunDtlNm)
          ? row.gubunDtlNm.join(',')
          : row.gubunDtlNm || '';
        return Commons.EncryptAES(gubunDtlNmValue) || '';
      },
      Comment: (row) => Commons.EncryptAES(row.comment || '') || '',
      IsPublic: (row) => Commons.EncryptAES(row.isPublic || '0') || '',
      CoCd: (row, context) => {
        const coCdValue =
          context.userInfo?.authCd === 'ADMIN'
            ? row.coCd || context.coCd || context.userInfo?.coCd
            : context.userInfo?.coCd;
        return Commons.EncryptAES(coCdValue || '') || '';
      },
      /** 구분 2(부서)일 때만 사업장 코드 전달 */
      CustCd: (row) =>
        Commons.EncryptAES(String(row.gubun) === '2' ? row.custCd || '' : '') ||
        '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    save2: {
      ChaebunNo: (row, context) =>
        Commons.EncryptAES(row.chaebunNo || '') || '',
      Date: (row, context) => {
        const dateValue = dayjs().format('YYYY-MM-DD');
        return Commons.EncryptAES(dateValue) || '';
      },
      FileName: (row) => Commons.EncryptAES(row.fileName || '') || '',
      SaveName: (row) => Commons.EncryptAES(row.saveName || '') || '',
      FilePath: (row, context) => {
        if (!row.filePath) return '';
        return Commons.EncryptAES(row.filePath || '') || '';
      },
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    delete1: {
      NoticeFId: (row) => Commons.EncryptAES(String(row.noticeFId || '')) || '',
    },
  },
};
